import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesTownHalls = {
  description: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageTownHallsInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesTownHalls}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageTownHallsInitializer.displayName = 'Page town halls initializer component';

export default PageTownHallsInitializer;
